/**
 * Sample Microsoft 365 data for the Inbox "Preview with sample data" mode.
 *
 * ⚠️ DEMO ONLY — this is NOT a live Microsoft 365 connection. It lets the team
 * preview the mail + calendar UI while Azure credentials/redirect-URI are being
 * finalised. Replace with the real Graph data by completing the connection.
 */
function isoFromNow(daysFromNow, hour, minute = 0) {
  const d = new Date();
  d.setDate(d.getDate() + daysFromNow);
  d.setHours(hour, minute, 0, 0);
  return d.toISOString();
}

export function demoMessages() {
  return [
    {
      id: "demo-m1",
      from: "Janet Holloway",
      subject: "Re: Acme Sports renewal — athlete-level benchmarks",
      preview:
        "Thanks for the walkthrough. Before we sign, can you send the injury-rate benchmarks by sport? Leadership wants them in the board pack.",
      received: isoFromNow(0, 8, 12),
      is_read: false,
      web_link: "#",
    },
    {
      id: "demo-m2",
      from: "Maya Singh",
      subject: "Claims triage — 2 flagged for MD escalation",
      preview:
        "Two concussion claims need medical-director review today. Documentation attached. One has incomplete broker paperwork — flagged.",
      received: isoFromNow(0, 7, 41),
      is_read: false,
      web_link: "#",
    },
    {
      id: "demo-m3",
      from: "Coach Reyes",
      subject: "Concussion protocol rollout — youth orgs",
      preview:
        "We're ready to pilot the return-to-play protocol with three clubs next month. Can your team join the kickoff call?",
      received: isoFromNow(-1, 16, 5),
      is_read: true,
      web_link: "#",
    },
    {
      id: "demo-m4",
      from: "Broker Desk — NorthStar",
      subject: "Q3 renewals: 92% retention target",
      preview:
        "Attaching the renewal pipeline. Devon is tracking 92% retention. Three accounts need a written follow-up after this week's calls.",
      received: isoFromNow(-1, 11, 23),
      is_read: true,
      web_link: "#",
    },
    {
      id: "demo-m5",
      from: "Players Health Ops",
      subject: "Morning brief is ready for your review",
      preview:
        "Your weekday brief drafted 2 emails and 1 calendar hold. Nothing has been sent — approve or skip from Briefings.",
      received: isoFromNow(-2, 7, 2),
      is_read: true,
      web_link: "#",
    },
  ];
}

export function demoEvents() {
  return [
    {
      id: "demo-e1",
      subject: "Claims triage — weekly",
      start: isoFromNow(0, 13, 0),
      location: "Teams",
      organizer: "Maya Singh",
      is_all_day: false,
      web_link: "#",
    },
    {
      id: "demo-e2",
      subject: "Acme Sports renewal — review benchmarks",
      start: isoFromNow(1, 10, 30),
      location: "Conf Room B",
      organizer: "Janet Holloway",
      is_all_day: false,
      web_link: "#",
    },
    {
      id: "demo-e3",
      subject: "Concussion protocol kickoff (youth orgs)",
      start: isoFromNow(2, 9, 0),
      location: "Teams",
      organizer: "Coach Reyes",
      is_all_day: false,
      web_link: "#",
    },
    {
      id: "demo-e4",
      subject: "Broker pulse — Q3 renewals",
      start: isoFromNow(3, 15, 0),
      location: "Teams",
      organizer: "Devon Park",
      is_all_day: false,
      web_link: "#",
    },
    {
      id: "demo-e5",
      subject: "Safety review — incident dashboard",
      start: isoFromNow(5, 0, 0),
      location: "",
      organizer: "Players Health",
      is_all_day: true,
      web_link: "#",
    },
  ];
}
